import React from "react";
import { AllUsers } from "../../components";

const Users = () => {
  return <AllUsers />;
};

export default Users;
